import { chakra } from '@chakra-ui/react';
import React from 'react';

import getDefaultTransitionProps from 'theme/utils/getDefaultTransitionProps';

const COUNTER_OVERLOAD = 50;

type Props = {
  count?: number | null;
};

const TabCounter = ({ count }: Props) => {

  if (count === undefined || count === null) {
    return null;
  }

  const displayCount = count > COUNTER_OVERLOAD ? `${ COUNTER_OVERLOAD }+` : count;

  return (
    <chakra.span
      color="inherit"
      ml={ 1 }
      { ...getDefaultTransitionProps() }
    >
      ({ displayCount })
    </chakra.span>
  );
};

export default TabCounter;
